import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Rate, Button } from 'antd';
import { FaMapMarkedAlt, FaRupeeSign } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { No_hotel } from '../../../utils/ImagePath';
import Loader from "./../../../utils/Loader";

const HotelCard = ({ item, fetchRoomDetails }) => {
  const loadingAllHotelList = useSelector(state => state.hotelData.loading);
  const hotelFilter = useSelector(state => state.hotelFilter.loading);
  const isPriceLoaded = useSelector(state => state.hotelData.isPriceLoaded);
  const roomInfo = JSON.parse(localStorage.getItem('roomInfo')) || [
    { numberOfAdults: 1, numberOfChild: 0, childAge: [] }];
  const [rooms, setRooms] = useState(roomInfo);
  return (
    <Card className="card mb-md-2 p-2" loading={loadingAllHotelList || hotelFilter} onClick={() => isPriceLoaded && fetchRoomDetails(item)} style={{ cursor: 'pointer' }}>
      <Row gutter={16}>
        <Col md={7} xs={24} className="d-flex pt-md-2 pb-md-2 ps-md-3"
        >
          <img
            src={item?.primary_image || item.img?.[0]?.url || No_hotel}
            className="img-fluid"
            alt="Hotel"
            loading="lazy"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = No_hotel;
            }}
            style={{ backgroundColor: '#eee', minHeight: '150px', cursor: 'pointer' }}
          />

        </Col>
        <Col md={17} xs={24} className="pt-md-3 pb-md-3 pe-md-3 mt-md-0 mt-3">
          <Row gutter={16} style={{ height: '100%' }}>
            <Col lg={17}>
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex align-items-center">
                  <Rate className='d-flex' disabled value={item?.rt} />
                  <span className="ms-2 lh-sm">{item?.pt}</span>
                </div>
                <div>
                  <b>{item?.rt}/5</b>
                  <p className="d-none d-md-inline mb-0 ms-2">Ratings</p>
                </div>
              </div>
              <h3 className="mb-md-2">{item.name}</h3>
              <h6><FaMapMarkedAlt className="me-1" />{item.ad.adr}</h6>
              <h6>{item.ad.adr2}</h6>
              <p className="mt-3 d-none">When you stay at Hotel Sidhartha in Agra, you'll be in the historical district, within a 5-minute dr...</p>
            </Col>
            <Col lg={7} xs={24} className="d-flex align-items-end justify-content-end border-start">
              <div className="price_cntr mt-2 mt-md-0">
                {item.pops[0].serviceTax !== "N/A" ?
                  <>
                    {!isPriceLoaded ? (
                      <div className="d-flex align-items-center justify-content-md-end gap-1 mb-1 mb-md-0">
                        <Loader size={30} height="50px" message="Finding Best Deal" />
                      </div>
                    ) : (
                      <div className='d-flex align-items-center justify-content-md-end gap-1 mb-1 mb-md-0'>
                        <p className='text-decoration-line-through'>
                          {Math.round(item.pops[0].totalPublishFare)}
                        </p>
                        <h2 className='lh-sm mb-0'>
                          <FaRupeeSign className='fs-5' />{Math.round(item.pops[0].tpc)}
                        </h2>
                      </div>
                    )}
                    <div className='d-flex d-md-block align-items-end justify-content-between'>
                      {!isPriceLoaded ? (
                        <>
                          <div style={{ height: 27 }} />
                          <Button className="btn btn-primary" aria-label="please wait">Please wait ...</Button>
                        </>
                      ) : (
                        <>
                          <div>
                            <p className='mb-0 lh-sm'>
                              +₹{Math.round(item.pops[0].serviceTax)} taxes &amp; fees
                            </p>
                            <p className='mb-1 lh-sm'>per night {rooms.length > 1 ? ' for ' + rooms.length + ' rooms' : ''}</p>
                          </div>
                          <Button className="btn btn-primary" onClick={() => isPriceLoaded && fetchRoomDetails(item)} aria-label="select room detail">
                            Select Room
                          </Button>
                        </>
                      )}
                    </div>

                  </>
                  :
                  <>
                    <div className='d-flex align-items-center justify-content-md-end gap-1 mb-2 mb-md-0'>
                      <h2 className='lh-sm'><FaRupeeSign className='fs-5' />{Math.round(item.pops[0].tpc)}</h2>
                    </div>
                    <div className='d-flex d-md-block align-items-end justify-content-between'>
                      <Button className="btn btn-primary" onClick={() => isPriceLoaded && fetchRoomDetails(item)} aria-label="select room">Select Room</Button>
                    </div>
                  </>

                }

              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

const TypewriterLoop = ({ words = [], typingSpeed = 150, pauseTime = 1000 }) => {
  const [text, setText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentWord = words[wordIndex % words.length];

    const timeout = setTimeout(() => {
      setText((prev) =>
        isDeleting ? currentWord.substring(0, prev.length - 1) : currentWord.substring(0, prev.length + 1)
      );

      if (!isDeleting && text === currentWord) {
        setTimeout(() => setIsDeleting(true), pauseTime);
      } else if (isDeleting && text === '') {
        setIsDeleting(false);
        setWordIndex((prev) => (prev + 1) % words.length);
      }
    }, isDeleting ? typingSpeed / 2 : typingSpeed);

    return () => clearTimeout(timeout);
  }, [text, isDeleting, wordIndex, words, typingSpeed, pauseTime]);

  return (
    <span style={{ whiteSpace: 'nowrap', fontFamily: 'monospace' }}>
      {text}
      <span className="blinking-cursor">|</span>

      <style>{`
          .blinking-cursor {
            animation: blink 1s step-start infinite;
          }
  
          @keyframes blink {
            50% { opacity: 0; }
          }
        `}</style>
    </span>
  );
};
export default HotelCard;